export const ResetPasscodePageStyles = {
    subHeader: 'flex items-center gap-3 justify-center mx-4 px-2',
    backArrowButton: 'cursor-pointer',
    subtitle: 'text-iw-textTertiary text-base font-medium',
    mainContent:
        'flex flex-col bg-white rounded-xl shadow-iw-pin-page-container mt-8 items-center relative z-20 px-4 sm:px-6 md:px-10 py-3 sm:py-5 md:py-7 space-y-4 w-[90%] sm-md:w-[85%] md:w-[50%]',
    resetPasscodeAction: 'mt-3 mb-0 sm:mt-3'
};
